import { Navigate, Route, Routes } from 'react-router-dom';
import LoginScreen from './routes/LoginScreen';
import MagicLink from './routes/MagicLink';
import OidcReturn from './routes/OidcReturn';
import Expired from './routes/Expired';
import {
  ROUTE_ROOT,
  ROUTE_LOGIN,
  ROUTE_MAGIC,
  ROUTE_OIDC_RETURN,
  ROUTE_EXPIRED,
} from './constants';

export default function App() {
  return (
    <Routes>
      <Route path={ROUTE_ROOT} element={<LoginScreen />} />
      <Route path={ROUTE_LOGIN} element={<LoginScreen />} />
      <Route path={ROUTE_MAGIC} element={<MagicLink />} />
      <Route path={ROUTE_OIDC_RETURN} element={<OidcReturn />} />
      <Route path={ROUTE_EXPIRED} element={<Expired />} />
      <Route path="*" element={<Navigate to={ROUTE_ROOT} replace />} />
    </Routes>
  );
}
